angular.module('logbook')
.run(['confirmationPopoverDefaults', function(confirmationPopoverDefaults) {
  confirmationPopoverDefaults['placement'] = 'auto';
  confirmationPopoverDefaults['popoverClass'] = 'confirm-popover';
 }]);
